(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const scriptUrl = "/js2/sienna.min.js";

        const loadScript = (url) => {
            const script = document.createElement('script');
            script.src = url;
            script.defer = true;
            document.body.appendChild(script);
        };

        loadScript(scriptUrl);

        const allyButton = document.querySelector('.ally-button');

        allyButton.addEventListener('click', function (event) {
            event.preventDefault();
            dataLayer.push({'event': 'ally_click'});

            const widgetButton = document.querySelector('.asw-menu-btn');
            if (!widgetButton) {
                return;
            }
            widgetButton.click();
        });
    });
})();
